import { forwardRef, createElement } from 'react';
import cn from 'classnames';
import { motion } from 'framer-motion';
import { useCurrentDialog } from '../Context.js';

const Drawer = /*#__PURE__*/forwardRef(function DialogDrawer(props, ref) {
  var _dialog$drawer, _dialog$drawer2;

  const dialog = useCurrentDialog();
  const className = cn('absolute top-0 z-[998] -ml-[4px] hidden h-full w-full overflow-y-auto rounded-r bg-white p-6 text-left', props.className);
  return createElement(motion.div, Object.assign({}, props, {
    className: className,
    "data-taco": "dialog-drawer",
    "aria-hidden": !((_dialog$drawer = dialog.drawer) !== null && _dialog$drawer !== void 0 && _dialog$drawer.open),
    variants: {
      visible: {
        left: '100%',
        display: 'block',
        transition: {
          ease: 'easeOut',
          duration: 0.2
        }
      },
      hidden: {
        left: '0%',
        transition: {
          ease: 'easeOut',
          duration: 0.2
        },
        transitionEnd: {
          display: 'none'
        }
      }
    },
    animate: (_dialog$drawer2 = dialog.drawer) !== null && _dialog$drawer2 !== void 0 && _dialog$drawer2.open ? 'visible' : 'hidden',
    ref: ref
  }), typeof props.children === 'function' ? props.children(dialog.drawer) : props.children);
});
Drawer.displayName = 'DialogDrawer';

export { Drawer };
//# sourceMappingURL=Drawer.js.map
